import React, { useEffect, useState } from 'react';
import {
    Alert, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle,
    List, ListItemButton, ListItemText
} from '@mui/material';

export default function FanPollQuestionIdeasDialog({
    open, loading, loadingMore, error, questions, onRefresh, onLoadMore, onClose, onSelect
}) {
    const [selected, setSelected] = useState('');

    useEffect(() => {
        if (open) setSelected('');
    }, [open]);

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle>Poll question inspiration</DialogTitle>
            <DialogContent dividers>
                {loading && <CircularProgress size={28} />}
                {error && <Alert severity="error">{error}</Alert>}
                {(questions ?? []).length > 0 && (
                    <List>
                        {(questions ?? []).map(question => (
                            <ListItemButton key={question} selected={selected === question}
                                onClick={() => setSelected(question)}>
                                <ListItemText primary={question} />
                            </ListItemButton>
                        ))}
                    </List>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onRefresh} disabled={loading || loadingMore}>Refresh ideas</Button>
                <Button onClick={onLoadMore} disabled={loading || loadingMore || !(questions ?? []).length}
                    startIcon={loadingMore ? <CircularProgress size={16} /> : undefined}>
                    Load more
                </Button>
                <Button onClick={onClose}>Cancel</Button>
                <Button variant="contained" disabled={!selected || loading || loadingMore}
                    onClick={() => onSelect(selected)}>
                    Use question
                </Button>
            </DialogActions>
        </Dialog>
    );
}
